<template>
  <BaseWrapper :loading="loading">
    <BaseCard title="Pencatatan Data Mitra Usaha">
      <form
        class="grid items-start gap-4 sm:grid-cols-2"
        @submit.prevent="onSubmit"
      >
        <BaseInput
          class="col-span-full"
          inset
          label="Pilihan Paket Pendaftaran"
          required
        >
          <SearchStockInput
            :origin-warehouse="{ id: me.current_warehouse }"
            :stock-request-params="{ 'filter[is_for_registration]': true }"
            :stock-modal-columns="['category', 'stock_real']"
            :original-search="productKit.originalSearch"
            :disabled="!!memberId"
            class="mt-1"
            :stock-modal-props="{
              title: 'Paket Pendaftaran',
              description: 'Paket Pendaftaran'
            }"
            @change="onChangeStock"
            @update:loading="(val) => (loadingSearchStock = val)"
            v-model="productKit.search"
          />
        </BaseInput>

        <template v-if="memberId || productKit.stockId">
          <template v-if="!memberId && productKit.category === 'DAFTAR ND'">
            <BaseInput
              label="Nomor Tetap Mitra Usaha"
              type="text"
              required
              inset
              placeholder="Masukkan Nomor Tetap Mitra Usaha"
              v-model="form.code"
            />
            <BaseInput
              label="Kode Aktivasi"
              type="password"
              required
              inset
              placeholder="Masukkan Kode Aktivasi"
              v-model="form.pin"
            />

            <div class="col-span-full justify-end flex flex-col sm:flex-row gap-2">
              <BaseButton class="w-full sm:w-auto" :disabled="disabledCreate"
                >Lanjut</BaseButton
              >
              <BaseButton :to="{ name: 'daftar-member' }" color="white" class="w-full sm:w-auto">
                <Icon icon="heroicons:arrow-uturn-left" />
                Kembali
              </BaseButton>
            </div>
          </template>
          <template v-else>
            <hr class="col-span-full" />

            <template v-if="memberId">
              <BaseInput
                v-if="form.codePrefix !== 'ND'"
                label="No. Sementara"
                type="text"
                readonly
                inset
                placeholder="Masukkan nama lengkap"
                v-model="form.tempCode"
              />
              <BaseInput
                v-else
                label="No. Tetap"
                type="text"
                readonly
                inset
                placeholder="Masukkan nama lengkap"
                v-model="form.code"
              />
            </template>

            <BaseInput
              :class="memberId ? '' : 'col-span-full'"
              label="Nama Mitra Usaha"
              type="text"
              required
              inset
              placeholder="Masukkan nama lengkap"
              v-model="form.name"
              @change="onUpdate('name', 'name')"
            />

            <template v-if="memberId">
              <hr class="col-span-full" />

              <BaseInput
                label="No. KTP/Identitas"
                type="text"
                required
                inset
                placeholder="Masukkan nomor identitas"
                :invalid="!!invalid.ktp"
                :message="invalid.ktp"
                v-model="form.ktp"
                @change="onUpdate('ktp_number', 'ktp')"
              />
              <BaseInput
                label="Email"
                type="email"
                inset
                placeholder="Masukkan alamat email"
                :invalid="!!invalid.email"
                :message="invalid.email"
                v-model="form.email"
                @change="onUpdate('email', 'email')"
              />
              <BaseInput
                label="No. HP"
                type="text"
                required
                inset
                placeholder="Masukkan nomor hp"
                :invalid="!!invalid.cellphone"
                :message="invalid.cellphone"
                v-model="form.cellphone"
                @change="onUpdate('cellphone', 'cellphone')"
              />
              <BaseInput
                label="Tanggal Lahir"
                type="date"
                required
                inset
                v-model="form.birthdate"
                @change="onUpdate('birthdate', 'birthdate')"
              />
              <BaseInput label="Pendidikan Terakhir" inset>
                <BaseSelect
                  inset
                  expand
                  :options="educationOptions"
                  v-model="form.education"
                  @change="onUpdate('education', 'education', 'educations')"
                />
              </BaseInput>
              <BaseInput label="Pekerjaan Terakhir" inset>
                <BaseSelect
                  inset
                  expand
                  :options="professionOptions"
                  v-model="form.profession"
                  @change="onUpdate('profession', 'profession', 'professions')"
                />
              </BaseInput>
              <BaseInput label="Jenis Kelamin">
                <div class="flex gap-8">
                  <BaseRadio
                    label="Laki-Laki"
                    id="sex_male"
                    val="male"
                    v-model="form.sex"
                    @change="onUpdate('sex', 'sex')"
                  />
                  <BaseRadio
                    label="Perempuan"
                    id="sex_female"
                    val="female"
                    v-model="form.sex"
                    @change="onUpdate('sex', 'sex')"
                  />
                </div>
              </BaseInput>
              <BaseInput label="Status Menikah">
                <div class="flex gap-8">
                  <BaseRadio
                    label="Menikah"
                    id="marital_married"
                    val="married"
                    v-model="form.marital"
                    @change="onUpdate('marital_status', 'marital')"
                  />
                  <BaseRadio
                    label="Belum Menikah"
                    id="marital_single"
                    val="single"
                    v-model="form.marital"
                    @change="onUpdate('marital_status', 'marital')"
                  />
                </div>
              </BaseInput>
              <template v-if="form.marital === 'married'">
                <BaseInput
                  label="Nama Pasangan"
                  type="text"
                  inset
                  placeholder="Masukkan nama lengkap"
                  v-model="form.spouseName"
                  @change="onUpdate('spouse_name', 'spouseName')"
                />
                <BaseInput
                  label="Tanggal Lahir Pasangan"
                  type="date"
                  inset
                  v-model="form.spouseBirthdate"
                  @change="onUpdate('spouse_birthdate', 'spouseBirthdate')"
                />
              </template>
              <BaseInput
                label="Nama Pewaris"
                type="text"
                inset
                placeholder="Masukkan nama lengkap"
                v-model="form.devisorName"
                @change="onUpdate('devisor_name', 'devisorName')"
              />
              <BaseInput
                label="Tanggal Lahir Pewaris"
                type="date"
                inset
                v-model="form.devisorBirthdate"
                @change="onUpdate('devisor_birthdate', 'devisorBirthdate')"
              />
              <BaseInput
                label="Jumlah Anak + Tanggungan"
                type="number"
                inset
                placeholder="Masukkan jumlah"
                v-model="form.dependents"
                @change="
                  onUpdate('dependents_number', 'dependents', null, true)
                "
              />
              <BaseInput
                v-if="form.marital === 'married'"
                label="Status Suami / Istri"
                inset
              >
                <BaseSelect
                  inset
                  expand
                  :options="spouseEmploymentOptions"
                  v-model="form.spouseEmployment"
                  @change="
                    onUpdate('spouse_employment_status', 'spouseEmployment')
                  "
                />
              </BaseInput>

              <hr class="col-span-full" />

              <BaseInput
                class="col-span-full"
                label="Alamat"
                tag="textarea"
                required
                inset
                placeholder="Nama Jalan, Nomor, RT/RW, Desa/Kelurahan"
                v-model="form.address"
                @change="onUpdate('address', 'address')"
              />
              <BaseInput label="Provinsi" inset required>
                <BaseSelect
                  inset
                  expand
                  :options="provinceOptions"
                  v-model="form.province"
                  @change="onUpdateAddress('province')"
                />
              </BaseInput>
              <BaseInput label="Kab/Kota" inset required>
                <BaseSelect
                  inset
                  expand
                  :options="cityOptions"
                  v-model="form.city"
                  @change="onUpdateAddress('city')"
                />
              </BaseInput>
              <BaseInput label="Kecamatan" inset required>
                <BaseSelect
                  inset
                  expand
                  :options="districtOptions"
                  v-model="form.district"
                  @change="onUpdateAddress('district')"
                />
              </BaseInput>
              <BaseInput label="Desa" inset required>
                <BaseSelect
                  inset
                  expand
                  :options="villageOptions"
                  v-model="form.village"
                  @change="onUpdateAddress('village')"
                />
              </BaseInput>
              <BaseInput
                label="Kode Pos"
                type="number"
                inset
                required
                placeholder="Masukkan Kode Pos"
                v-model="form.postCode"
                @change="onUpdate('postal_code', 'postCode')"
              />
              <BaseInput
                label="Wilayah Harga"
                inset
                disabled
                placeholder="Wilayah Harga"
                v-model="form.area"
              />

              <hr class="col-span-full" />

              <h2 class="col-span-full font-medium text-gray-900">
                Data Komisi
              </h2>
              <SearchOfficeInput
                label="Tempat Pengambilan Komisi"
                required
                placeholder="Masukkan kode stockist"
                office-type="stockist"
                v-model="bonusOffice"
              />
              <BaseInput
                label="Nama Stockist"
                inset
                disabled
                placeholder="Nama Stockist"
                v-model="bonusOffice.name"
              />
              <BaseInput label="KTA">
                <BaseCheckbox
                  label="Dikirim langsung ke alamat mitra usaha"
                  v-model="form.ktaDelivery"
                  @change="onUpdate('is_kta_need_delivery', 'ktaDelivery')"
                />
              </BaseInput>

              <hr class="col-span-full" />

              <div class="col-span-full">
                <h2 class="font-medium text-gray-900">Data Bank</h2>
                <p class="text-sm text-gray-500">
                  Data ini digunakan untuk pencarian bonus
                </p>
              </div>
              <BaseInput label="Nama Bank" inset>
                <BaseSelect
                  inset
                  expand
                  :options="bankOptions"
                  v-model="form.bank"
                  @change="onUpdate('bank', 'bank', 'banks')"
                />
              </BaseInput>
              <BaseInput
                label="No. Rekening"
                type="number"
                inset
                placeholder="Masukkan No. Rekening"
                v-model="form.bankAccountNumber"
                @change="onUpdate('bank_account_number', 'bankAccountNumber')"
              />
              <BaseInput
                label="Cabang Bank"
                type="text"
                inset
                placeholder="Masukkan Cabang Bank"
                v-model="form.bankBranchName"
                @change="onUpdate('bank_branch_name', 'bankBranchName')"
              />
              <BaseInput
                label="Nama Rekening"
                type="text"
                inset
                placeholder="Masukkan Nama Rekening"
                v-model="form.bankAccountName"
                @change="onUpdate('bank_account_name', 'bankAccountName')"
              />

              <hr class="col-span-full" />

              <h2 class="col-span-full font-medium text-gray-900">Data NPWP</h2>
              <BaseInput
                label="No. NPWP"
                type="number"
                inset
                placeholder="Masukkan No. NPWP"
                v-model="form.npwpNumber"
                @change="onUpdate('npwp_number', 'npwpNumber')"
              />
              <BaseInput
                label="Nama NPWP"
                type="text"
                inset
                placeholder="Masukkan Nama NPWP"
                v-model="form.npwpName"
                @change="onUpdate('npwp_name', 'npwpName')"
              />

              <hr class="col-span-full" />

              <h2 class="col-span-full font-medium text-gray-900">
                Data Referal
              </h2>
              <SearchOfficeInput
                label="Nomor Upline"
                required
                placeholder="Masukkan kode referal"
                office-type="member"
                filter-active
                v-model="upline"
              />
              <BaseInput
                label="Nama Upline"
                inset
                disabled
                placeholder="Nama Upline"
                v-model="upline.name"
              />

              <hr class="col-span-full" />

              <div
                class="col-span-full grid grid-cols-1 justify-end gap-2 sm:flex"
              >
                <template v-if="draft">
                  <BaseButton :disabled="!valid">
                    <Icon icon="heroicons:check-badge-solid" />
                    Validasi Mitra
                  </BaseButton>
                  <BaseButton
                    v-if="form.codePrefix !== 'ND'"
                    type="button"
                    color="danger"
                    @click="deleteConfirmVisible = true"
                  >
                    <Icon icon="heroicons:trash-solid" />
                    Hapus
                  </BaseButton>
                </template>
                <BaseButton :to="{ name: 'daftar-member' }" color="white">
                  <Icon icon="heroicons:arrow-uturn-left" />
                  Kembali
                </BaseButton>
              </div>
            </template>
          </template>
        </template>
      </form>

      <div v-if="productKit.category !== 'DAFTAR ND' && !memberId" class="flex justify-end mt-4">
        <BaseButton :to="{ name: 'daftar-member' }" color="white" class="w-full sm:w-auto">
          <Icon icon="heroicons:arrow-uturn-left" />
          Kembali
        </BaseButton>
      </div>

      <BaseConfirm
        :visible="deleteConfirmVisible"
        icon-type="badge"
        title="Hapus Mitra Usaha"
        message="Apakah anda yakin ingin menghapus mitra usaha ini?"
        @close="deleteConfirmVisible = false"
        @confirmed="onDelete"
      />
      <BaseConfirm
        type="success"
        :with-action="false"
        :visible="successValidateVisible"
        icon-type="badge"
        title="Mitra Usaha Berhasil Divalidasi"
        message="Data mitra berhasil disimpan, segera lakukan validasi pembayaran di halaman kasir > pembayaran"
        @close="$router.push({ name: 'daftar-member' })"
      />
    </BaseCard>
  </BaseWrapper>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchStockInput from '../../../../../components/stock/search-stock-input.vue';
import { requestMixin } from '../../../../../mixins/request/request';
import BaseRadio from '../../../../../components/base/BaseRadio.vue';
import SearchOfficeInput from '../../../../../components/office/search-office-input.vue';
import BaseCheckbox from '../../../../../components/base/BaseCheckbox.vue';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: {
    SearchStockInput,
    SearchOfficeInput,
    BaseRadio,
    BaseCheckbox,
    BaseConfirm,
  },
  data() {
    return {
      loadingSearchStock: false,
      loadingUpdate: false,
      loadingMember: false,
      loadingEducation: false,
      loadingProfession: false,
      loadingProvinces: false,
      loadingCities: false,
      loadingDistricts: false,
      loadingVillages: false,
      loadingBanks: false,
      loadingMe: false,
      loadingDelete: false,
      loadingCheckNd: false,
      deleteConfirmVisible: false,
      successValidateVisible: false,
      draft: true,
      educations: {
        data: [],
      },
      professions: {
        data: [],
      },
      provinces: {
        data: [],
      },
      districts: {
        data: [],
      },
      cities: {
        data: [],
      },
      villages: {
        data: [],
      },
      banks: {
        data: [],
      },
      memberId: null,
      productKit: {
        originalSearch: null,
        search: null,
        stockId: null,
        productId: null,
        category: null,
      },
      bonusOffice: {
        id: null,
        code: null,
        searchCode: null,
        originalCode: null,
        name: null,
      },
      upline: {
        id: null,
        code: null,
        searchCode: null,
        originalCode: null,
        name: null,
      },
      form: {
        code: null,
        codePrefix: null,
        name: null,
        pin: null,
        tempCode: null,
        ktp: null,
        email: null,
        cellphone: null,
        birthdate: null,
        education: null,
        profession: null,
        sex: null,
        marital: null,
        spouseName: null,
        spouseBirthdate: null,
        devisorName: null,
        devisorBirthdate: null,
        dependents: null,
        spouseEmployment: null,
        address: null,
        province: null,
        district: null,
        city: null,
        village: null,
        postCode: null,
        area: null,
        ktaDelivery: false,
        bank: null,
        bankAccountName: null,
        bankAccountNumber: null,
        bankBranchName: null,
        npwpName: null,
        npwpNumber: null,
      },
      invalid: {
        ktp: null,
        email: null,
        cellphone: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    valid() {
      return (
        this.form.name &&
        this.form.ktp &&
        this.form.cellphone &&
        this.form.birthdate &&
        this.form.address &&
        this.form.province &&
        this.form.city &&
        this.form.district &&
        this.form.village &&
        this.form.postCode &&
        this.upline.code
      );
    },
    disabledCreate() {
      if (this.productKit.category === 'DAFTAR ND') {
        return !this.form.code || !this.form.pin;
      }

      return !this.form.name;
    },
    loading() {
      return (
        this.loadingSearchStock ||
        this.loadingUpdate ||
        this.loadingMember ||
        this.loadingEducation ||
        this.loadingProfession ||
        this.loadingProvinces ||
        this.loadingCities ||
        this.loadingDistricts ||
        this.loadingVillages ||
        this.loadingMe ||
        this.loadingBanks ||
        this.loadingDelete ||
        this.loadingCheckNd
      );
    },
    educationOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Pendidikan',
        },
        ...this.educations.data.map((education) => ({
          key: education.id,
          value: education.id,
          label: education.attributes.name,
        })),
      ];
    },
    professionOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Pekerjaan',
        },
        ...this.professions.data.map((profession) => ({
          key: profession.id,
          value: profession.id,
          label: profession.attributes.name,
        })),
      ];
    },
    spouseEmploymentOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Status Suami / Istri',
        },
        {
          key: 'bekerja',
          value: true,
          label: 'Bekerja',
        },
        {
          key: 'tidak_bekerja',
          value: false,
          label: 'Tidak Bekerja',
        },
      ];
    },
    provinceOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Provinsi',
        },
        ...this.provinces.data.map((province) => ({
          key: province.id,
          value: province.id,
          label: province.attributes.name,
        })),
      ];
    },
    cityOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Kota',
        },
        ...this.cities.data.map((city) => ({
          key: city.id,
          value: city.id,
          label: city.attributes.name,
        })),
      ];
    },
    districtOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Kecamatan',
        },
        ...this.districts.data.map((district) => ({
          key: district.id,
          value: district.id,
          label: district.attributes.name,
        })),
      ];
    },
    villageOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Desa',
        },
        ...this.villages.data.map((village) => ({
          key: village.id,
          value: village.id,
          label: village.attributes.name,
        })),
      ];
    },
    bankOptions() {
      return [
        {
          key: 'all',
          value: null,
          label: 'Pilih Bank',
        },
        ...this.banks.data.map((bank) => ({
          key: bank.id,
          value: bank.id,
          label: bank.attributes.name,
        })),
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    getKeyValue(key) {
      const value = this.form[key];

      if (value === null) {
        return null;
      }

      if (typeof value === 'boolean') {
        return value;
      }

      if (isNaN(value)) {
        return value;
      }

      return Number(value);
    },
    async createMember() {
      const [res, err] = await this.request(
        `/api/v1/offices/-actions/createMember`,
        {
          method: 'post',
          params: {
            name: this.form.name,
            product_id: this.productKit.productId,
          },
        }
      );

      if (!err) {
        await this.loadMember(res.data.id)

        this.$router.push({
          name: 'daftar-member.edit',
          params: {
            id: res.data.id,
          },
        });
      }
    },
    async checkNd() {
      this.loadingCheckNd = true;

      const [res, err] = await this.request(
        `/api/v1/offices/-actions/update-register-by`,
        {
          method: 'patch',
          data: {
            code: this.form.code,
            pin: this.form.pin,
            registration_product_uuid: this.productKit.productId,
          },
        }
      );

      if (err) {
        this.createAlert({
          type: 'confirm',
          status: 'error',
          data: this.getRequestErrorMessage(err),
          autoClose: false,
        });
      } else {
        await this.loadMember(res.data.id);

        this.$router.push({
          name: 'daftar-member.edit',
          params: {
            id: res.data.id,
          },
        });
      }

      this.loadingCheckNd = false;
    },
    async updateMember(attribute, key, relationType, cast = false) {
      this.invalid[key] = null;

      const [, err] = await this.request(`/api/v1/offices/${this.memberId}`, {
        method: 'patch',
        data: {
          data: {
            type: 'offices',
            id: this.memberId,
            ...(!relationType
              ? {
                  attributes: {
                    [attribute]: cast ? this.getKeyValue(key) : this.form[key],
                  },
                }
              : {}),
            ...(relationType
              ? {
                  relationships: {
                    [attribute]: {
                      data: this.form[key]
                        ? {
                            type: relationType,
                            id: this.form[key],
                          }
                        : null,
                    },
                  },
                }
              : {}),
          },
        },
      });

      if (err) {
        this.invalid[key] = this.getRequestErrorMessage(err);
      }
    },
    async validateMember() {
      this.loadingUpdate = true;

      const [, err] = await this.request(
        `/api/v1/offices/${this.memberId}/-actions/validate-member`,
        {
          method: 'patch',
          data: {
            bonus_office_id: this.bonusOffice.id,
            upline_office_id: this.upline.id,
          },
        }
      );

      if (err) {
        this.createAlert({
          type: 'confirm',
          status: 'error',
          data: this.getRequestErrorMessage(err),
          autoClose: false,
        });
      } else {
        this.successValidateVisible = true;
      }

      this.loadingUpdate = false;
    },
    async loadEducations() {
      this.loadingEducation = true;

      const [res, err] = await this.request(`/api/v1/educations`, {
        params: {
          'fields[educations]': 'name',
        },
      });

      if (!err) {
        this.educations = res;
      }

      this.loadingEducation = false;
    },
    async loadProfessions() {
      this.loadingProfession = true;

      const [res, err] = await this.request(`/api/v1/professions`, {
        params: {
          'fields[professions]': 'name',
        },
      });

      if (!err) {
        this.professions = res;
      }

      this.loadingProfession = false;
    },
    async loadBanks() {
      this.loadingBank = true;

      const [res, err] = await this.request(`/api/v1/banks`, {
        params: {
          'fields[banks]': 'name',
          'filter[is_mitra_bank]': true,
        },
      });

      if (!err) {
        this.banks = res;
      }

      this.loadingBank = false;
    },
    async loadProvinces() {
      this.loadingProvinces = true;

      const [res, err] = await this.request(`/api/v1/provinces`, {
        params: {
          'fields[provinces]': 'name',
        },
      });

      if (!err) {
        this.provinces = res;
      }

      this.loadingProvinces = false;
    },
    async loadCities() {
      this.loadingCities = true;

      const [res, err] = await this.request(
        `/api/v1/provinces/${this.form.province}/cities`,
        {
          params: {
            'fields[cities]': 'name',
          },
        }
      );

      if (!err) {
        this.cities = res;
      }

      this.loadingCities = false;
    },
    async loadDistricts() {
      this.loadingDistricts = true;

      const [res, err] = await this.request(
        `/api/v1/cities/${this.form.city}/districts`,
        {
          params: {
            'fields[districts]': 'name',
          },
        }
      );

      if (!err) {
        this.districts = res;
      }

      this.loadingDistricts = false;
    },
    async loadVillages() {
      this.loadingVillages = true;

      const [res, err] = await this.request(
        `/api/v1/districts/${this.form.district}/villages`,
        {
          params: {
            'fields[villages]': 'name',
          },
        }
      );

      if (!err) {
        this.villages = res;
      }

      this.loadingVillages = false;
    },
    async loadMe() {
      this.loadingMe = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.me.office_id}`,
        {
          params: {
            'fields[offices]': 'code,name',
          },
        }
      );

      if (!err) {
        this.bonusOffice.id = res.data.id;
        this.bonusOffice.code = res.data.attributes.code;
        this.bonusOffice.searchCode = res.data.attributes.code;
        this.bonusOffice.originalCode = res.data.attributes.code;
        this.bonusOffice.name = res.data.attributes.name;
      }

      this.loadingMe = false;
    },
    async loadMember(id) {
      this.loadingMember = true;

      const [res, err] = await this.request(`/api/v1/offices/${id}`, {
        params: {
          include:
            'registration-product,education,profession,default-address,bank',
          'fields[offices]':
            'is_draft,registration-product,name,temp_code,code,code_prefix,ktp_number,email,cellphone,birthdate,education,profession,sex,marital_status,spouse_name,spouse_birthdate,devisor_name,devisor_birthdate,dependents_number,spouse_employment_status,address,default-address,postal_code,area_code,is_kta_need_delivery,bank,bank_branch_name,bank_account_name,bank_account_number,npwp_name,npwp_number,upline_histories',
          'fields[products]': 'code',
          'fields[educations]': 'name',
          'fields[professions]': 'name',
          'fields[banks]': 'name',
          'fields[addresses]': 'province_id,city_id,district_id,village_id',
        },
      });

      if (!err) {
        this.memberId = res.data.id;
        this.draft = res.data.attributes.is_draft;

        const registrationProduct = this.getSingleIncluded(
          res,
          res.data.relationships['registration-product'].data.id
        );

        this.productKit.search = registrationProduct.attributes.code;

        this.form.name = res.data.attributes.name;
        this.form.code = res.data.attributes.code;
        this.form.codePrefix = res.data.attributes.code_prefix;
        this.form.tempCode = res.data.attributes.temp_code;
        this.form.ktp = res.data.attributes.ktp_number;
        this.form.email = res.data.attributes.email;
        this.form.cellphone = res.data.attributes.cellphone;
        this.form.birthdate = res.data.attributes.birthdate;
        this.form.education = res.data.relationships['education'].data
          ? res.data.relationships['education'].data.id
          : null;
        this.form.profession = res.data.relationships['profession'].data
          ? res.data.relationships['profession'].data.id
          : null;
        this.form.sex = res.data.attributes.sex;
        this.form.marital = res.data.attributes.marital_status;
        this.form.spouseName = res.data.attributes.spouse_name;
        this.form.spouseBirthdate = res.data.attributes.spouse_birthdate;
        this.form.devisorName = res.data.attributes.devisor_name;
        this.form.devisorBirthdate = res.data.attributes.devisor_birthdate;
        this.form.dependents = res.data.attributes.dependents_number;
        this.form.spouseEmployment =
          res.data.attributes.spouse_employment_status;
        this.form.address = res.data.attributes.address;
        this.form.postCode = res.data.attributes.postal_code;
        this.form.area = res.data.attributes.area_code;
        this.form.ktaDelivery = res.data.attributes.is_kta_need_delivery;
        this.form.bank = res.data.relationships['bank'].data
          ? res.data.relationships['bank'].data.id
          : null;
        this.form.bankBranchName = res.data.attributes.bank_branch_name;
        this.form.bankAccountName = res.data.attributes.bank_account_name;
        this.form.bankAccountNumber = res.data.attributes.bank_account_number;
        this.form.npwpName = res.data.attributes.npwp_name;
        this.form.npwpNumber = res.data.attributes.npwp_number;

        const defaultAddressRel =
          res.data.relationships['default-address'].data;

        if (defaultAddressRel) {
          const defaultAddress = this.getSingleIncluded(
            res,
            defaultAddressRel.id
          );

          this.form.province = defaultAddress.attributes.province_id;
          this.form.city = defaultAddress.attributes.city_id;
          this.form.district = defaultAddress.attributes.district_id;
          this.form.village = defaultAddress.attributes.village_id;

          if (this.form.province) {
            this.loadCities();
          }

          if (this.form.city) {
            this.loadDistricts();
          }

          if (this.form.district) {
            this.loadVillages();
          }
        }

        const uplineHistories = res.data.attributes.upline_histories;

        if (Array.isArray(uplineHistories)) {
          const referral = uplineHistories.find(
            (upline) => upline.type === 'referred_by'
          );

          if (referral) {
            this.upline.id = null;
            this.upline.code = referral.code;
            this.upline.searchCode = referral.code;
            this.upline.originalCode = referral.code;
            this.upline.name = referral.name;
          }
        }
      }

      this.loadingMember = false;
    },
    onChangeStock(e) {
      const { stock, product } = e;

      this.productKit.search = stock.attributes.product_code;
      this.productKit.originalSearch = stock.attributes.product_code;
      this.productKit.category = stock.attributes.product_category_code;
      this.productKit.stockId = stock.id;
      this.productKit.productId = product.id;

      this.form.name = null;
      this.form.pin = null;

      if (e.closeModal) {
        e.closeModal();
      }
    },
    async onSubmit() {
      if (this.memberId) {
        this.validateMember();
      } else {
        this.checkNd();
      }
    },
    async onUpdate(attribute, key, relationType, cast = false) {
      this.loadingUpdate = true;

      if (!this.memberId) {
        await this.createMember();
      } else {
        await this.updateMember(attribute, key, relationType, cast);
      }

      this.loadingUpdate = false;
    },
    async onUpdateAddress(key) {
      this.loadingUpdate = true;

      if (key === 'province') {
        if (this.form.province) {
          await this.loadCities();
        }

        this.form.city = null;
        this.form.district = null;
        this.form.village = null;
      } else if (key === 'city') {
        if (this.form.city) {
          await this.loadDistricts();
        }

        this.form.district = null;
        this.form.village = null;
      } else if (key === 'district') {
        if (this.form.district) {
          await this.loadVillages();
        }

        this.form.village = null;
      }

      if (
        this.form.province &&
        this.form.city &&
        this.form.district &&
        this.form.village
      ) {
        const [res, err] = await this.request(
          `/api/v1/offices/${this.memberId}`,
          {
            method: 'patch',
            data: {
              data: {
                type: 'offices',
                id: this.memberId,
                attributes: {
                  address_details: [
                    {
                      province_id: this.form.province,
                      city_id: this.form.city,
                      district_id: this.form.district,
                      village_id: this.form.village,
                    },
                  ],
                },
              },
            },
          }
        );

        if (!err) {
          this.form.area = res.data.attributes.area_code;
        }
      }

      this.loadingUpdate = false;
    },
    async onDelete() {
      this.loadingDelete = true;

      const [, err] = await this.request(`/api/v1/offices/${this.memberId}`, {
        method: 'patch',
        data: {
          data: {
            type: 'offices',
            id: this.memberId,
            attributes: {
              deletedAt: new Date(),
            },
          },
        },
      });

      if (!err) {
        this.$router.push({ name: 'daftar-member' });
      }

      this.loadingDelete = false;
    },
  },
  created() {
    this.loadMe();

    if (this.$route.params.id) {
      this.loadMember(this.$route.params.id);
    }

    this.loadEducations();
    this.loadProfessions();
    this.loadProvinces();
    this.loadBanks();
  },
};
</script>
